/* eslint-disable @typescript-eslint/no-inferrable-types */
import {
  CreditNoteDataEntryForm,
  CreditNoteProductEntries,
  PaginatedCreditNotes,
  PreviewResponseCreditNote,
} from "types/model.types";
import { authApi } from "./";

export const getCreditInvoices = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedCreditNotes> => {
  const { data } = await authApi.post<PaginatedCreditNotes>("crnote/get", {
    pageNumber,
    pageSize,
  });
  return data ?? [];
};
export const deleteAdminCreditNote = async (
  id: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>(`crnote/deleteAdminCrNote`, {
    id,
  });
  return data;
};
/**
 *
 * @param id Get credit journal records by ID
 * @returns
 */
export const getById = async (id: number): Promise<CreditNoteDataEntryForm> => {
  return await authApi
    .post<CreditNoteDataEntryForm>("crnote/getById", { id })
    .then((resp) => resp.data);
};
export const getPreview = async (
  id: number,
): Promise<PreviewResponseCreditNote> => {
  return await authApi
    .post<PreviewResponseCreditNote>("crnote/getPreview", { id })
    .then((resp) => resp.data);
};

export const getOrderInfoByInvoice = async (
  id: number,
): Promise<CreditNoteProductEntries> => {
  return await authApi
    .post<CreditNoteProductEntries>("crnote/getOrderInfoByInvoice", {
      id,
    })
    .then((res) => res.data);
};
export const deleteJournalDetails = async (
  journalId: number,
  journalDetailId: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>("crnote/deleteDetails", {
    journalId,
    journalDetailId,
  });
  return data;
};
export const submitCrInvoice = async (
  payload: any,
): Promise<void | CreditNoteDataEntryForm> => {
  const { data } = await authApi.post<CreditNoteDataEntryForm>(
    "crnote/submit",
    payload,
  );
  return data;
};
export const getCrInvoiceById = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedCreditNotes> => {
  throw new Error("Function not implemented.");
  const { data } = await authApi.post<PaginatedCreditNotes>("crnote/get", {
    pageNumber,
    pageSize,
  });
  return data;
};
export const getCrInvoiceAndDetails = (
  id: number,
): Promise<CreditNoteDataEntryForm> => {
  return authApi
    .post<CreditNoteDataEntryForm>("crnote/getById", { id })
    .then((res) => res.data);
};
export const deleteCrInvoiceDetails = async (
  recordId: number,
  detailIds: number[],
): Promise<void | any> => {
  const { data } = await authApi.post("crnote/deleteDetails", {
    recordId,
    detailIds,
  });
  return data;
};
export const deleteAllCrInvoiceDetails = async (
  recordId: number,
): Promise<void | any> => {
  const { data } = await authApi.post("crnote/deleteAllDetails", {
    recordId,
  });
  return data;
};
